import { render, staticRenderFns } from "./ClosedPositions.vue?vue&type=template&id=d0ec5364&scoped=true"
import script from "./ClosedPositions.vue?vue&type=script&lang=js"
export * from "./ClosedPositions.vue?vue&type=script&lang=js"
import style0 from "./ClosedPositions.vue?vue&type=style&index=0&id=d0ec5364&prod&lang=scss&scoped=true"
import style1 from "./ClosedPositions.vue?vue&type=style&index=1&id=d0ec5364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ec5364",
  null
  
)

export default component.exports